<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/12QzRmW/images/9780316403405.jpg?1733067611627" alt="This image is the cover for the book Play On"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Play On
      </h1>
      <p class="bookDescription body article font2">
        <b>“Fleetwood documents his wild life, including how the creation of <i>Rumours</i>, one of the bestselling albums of all time, almost drove the band insane.” —Larry Getlen, <i>New York Post</i></b><br/><br/>“This is the story of my life in rock and roll—and how the band that has meant everything to me came to define me. I'm looking forward to sharing it with you.”<br/><br/>Mick Fleetwood has been a member of the ever-evolving Fleetwood Mac, one of the world's most successful and adored bands, for over four decades. Here he tells the full and candid story of his life as one of music's greatest drummers and bandleaders, the cofounder of the deeply loved supergroup that bears his name and that of his bandmate and lifelong friend John McVie. In this intimate portrait of a life lived in music, Fleetwood vividly recalls his upbringing tapping along to every song playing on the radio, his experiences as a musician in '60s London, and the earliest permutation of the band featuring Peter Green.<br/><br/><i>Play On</i> sheds new light on Fleetwood Mac's raucous history, describing the highs and lows of being in the band that Fleetwood was determined to keep together. Here he reflects on the creation of landmark albums such as Rumours and Tusk, the great loves of his life, and the many incredible and outrageous moments of recording, touring, and living with Fleetwood Mac. <br/><br/>Through it all, from intense love to plaintive heartaches, from collaborations to confrontations, it's been the drive to play on that has prevailed. Now, then, and always, it's Fleetwood Mac.<br/><br/>“<i>Play On</i> speaks openly about Fleetwood's various marriages, personal failure and reconciliation.” ―<i>Newsweek</i>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Mick Fleetwood, Anthony Bozza
      </h2>
      
      <p class="authorDescription body article"><B>Anthony Bozza</B> is a former writer for <I>Rolling Stone</I> and the author of several <I>New York Times </I>and <I>London Sunday Times</I> bestsellers, including his first book, <I>Whatever You Say I Am: The Life and Times of Eminem</I>. He lives in New York City.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Little, Brown and Company
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?1e1eacda